import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useLocation } from 'react-router-dom';
import Pagination10 from './components/Pagination10';
import ResponsiveShadow from './components/ResponsiveShadow';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ConfirmModal from './components/modals/ConfirmModal';
import usePagination10 from './components/hooks/usePagination10';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import VinculoModal from './components/modals/VinculoModal';
import TableContainer from './components/TableContainer';
import DataTable from './components/DataTable';
import PaginationBar from './components/PaginationBar';

function Vinculos() {
  const [Usuario, setUsuario] = useState({
    cpf: '',
    nome: '',
    login: '',
    senha: '',
    situacao: '',
    role: '',
  });
  const [Entidade, setEntidade] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [Vinculos, setVinculos] = useState([]);
  const [atualizar, setAtualizar] = useState(false);
  const [selectedVinculo, setSelectedVinculo] = useState(null);
  const [showVinculoModal, setShowVinculoModal] = useState(false);
  const [editingVinculo, setEditingVinculo] = useState(null);
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const totalItems = Vinculos.length;
  const { setPagination } = usePagination10(totalItems);
  const displayedUsuarios = Vinculos.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  useEffect(() => {
    if (location.state && location.state.usuario) {
      setUsuario(location.state.usuario);
    }
    if (location.state && location.state.entidade) {
      setEntidade(location.state.entidade);
    }
  }, [location.state]);

  useEffect(() => {
    if (Entidade && Entidade.idEntidade) {
      axios
        .get(`${API_BASE_URL.VINCULO}/entidade`, {
          params: { idEntidade: Entidade.idEntidade },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          setVinculos(result.data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Erro ao obter registros:', error);
        });
    } else if (Usuario.cpf !== '') {
      axios
        .get(`${API_BASE_URL.VINCULO}/cpf`, {
          params: { cpf: Usuario.cpf },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          setVinculos(result.data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Erro ao obter registros:', error);
        });
    }
  }, [Usuario.cpf, Entidade, token, atualizar]);

  // Limpar seleção quando o filtro ou paginação mudar
  useEffect(() => {
    if (
      selectedVinculo &&
      !displayedUsuarios.find(
        v => v.idEntidade === selectedVinculo.idEntidade && v.cpf === selectedVinculo.cpf
      )
    ) {
      setSelectedVinculo(null);
    }
  }, [displayedUsuarios, selectedVinculo]);

  const handleRowClick = vinculo => {
    setSelectedVinculo(
      selectedVinculo &&
        selectedVinculo.idEntidade === vinculo.idEntidade &&
        selectedVinculo.cpf === vinculo.cpf
        ? null
        : vinculo
    );
  };

  const handleCreateVinculo = () => {
    setEditingVinculo(null);
    setShowVinculoModal(true);
  };

  const handleEditVinculo = () => {
    if (selectedVinculo) {
      setEditingVinculo(selectedVinculo);
      setShowVinculoModal(true);
    }
  };

  const handleVinculoSuccess = () => {
    setShowVinculoModal(false);
    setEditingVinculo(null);
    setAtualizar(!atualizar);
    showDefaultModal(
      'success',
      editingVinculo
        ? 'Vínculo atualizado com sucesso!'
        : 'Vínculo criado com sucesso!'
    );
  };

  const handleVinculoClose = () => {
    setShowVinculoModal(false);
    setEditingVinculo(null);
  };

  function handleDelete(usuarioToDelete) {
    showConfirmModal('delete', () => handleConfirmDelete(usuarioToDelete));
  }

  function handleConfirmDelete(usuarioToDelete) {
    axios
      .delete(
        `${API_BASE_URL.VINCULO}/delete/${usuarioToDelete.cpf}/${usuarioToDelete.idEntidade}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setAtualizar(!atualizar);
        showDefaultModal('success', 'O registro foi excluído com sucesso!');
      })
      .catch(error => {
        console.error('Erro ao deletar:', error);
        showDefaultModal('error', 'Erro ao excluir o registro');
      });
  }

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader
          title={Entidade ? `Vínculos - ${Entidade.nome}` : "Vinculação de Usuários"}
          icon="bi-link-45deg"
          closeRoute={Entidade ? "/entidades" : "/usuarios"}
        />
        <PageContent>
          <div className="d-flex flex-column flex-lg-row justify-content-lg-between gap-2 mb-2 align-items-start align-items-lg-center">
            <div className="botao-grid-2col">
              <button
                className="btn btn-success btn-sm botao-igual d-inline-flex align-items-center"
                onClick={handleCreateVinculo}
                title="Criar novo vínculo"
              >
                <i className="bi bi-plus-circle me-1"></i>Novo
              </button>
              <button
                className="btn btn-primary btn-sm botao-igual"
                disabled={!selectedVinculo}
                onClick={handleEditVinculo}
                title="Editar vínculo selecionado"
              >
                <i className="bi bi-pencil-square me-1"></i>Editar
              </button>
              <button
                className="btn btn-danger btn-sm botao-igual"
                onClick={() => handleDelete(selectedVinculo)}
                title="Excluir vínculo"
                disabled={!selectedVinculo}
              >
                <i className="bi bi-trash3 me-1"></i>Excluir
              </button>
            </div>
          </div>
        
            <TableContainer isLoading={isLoading}>
              <DataTable style={{ fontSize: '0.8rem' }} head={
                <tr>
                  {Entidade ? (
                    <>
                      <th scope="col" style={{ minWidth: '200px' }}>Usuário</th>
                      <th scope="col" style={{ minWidth: '120px' }}>CPF</th>
                    </>
                  ) : (
                    <>
                      <th scope="col" style={{ minWidth: '200px' }}>Nome</th>
                      <th scope="col" style={{ minWidth: '150px' }}>Cidade</th>
                      <th scope="col" style={{ minWidth: '60px' }}>UF</th>
                    </>
                  )}
                  <th scope="col" style={{ minWidth: '150px' }}>Tipo de Vínculo</th>
                </tr>
              }>
              <tbody>
                {displayedUsuarios.length > 0 ? (
                  displayedUsuarios.map(usu => {
                    const isActiveRow =
                      selectedVinculo &&
                      selectedVinculo.idEntidade === usu.idEntidade &&
                      selectedVinculo.cpf === usu.cpf;
                    return (
                      <tr
                        key={`${usu.idEntidade}-${usu.cpf}`}
                        className={isActiveRow ? 'table-primary' : ''}
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleRowClick(usu)}
                        title={
                          isActiveRow
                            ? 'Vínculo selecionado'
                            : 'Clique para selecionar'
                        }
                      >
                        {Entidade ? (
                          <>
                            <td>{usu.usuario?.nome || '-'}</td>
                            <td>{usu.cpf}</td>
                          </>
                        ) : (
                          <>
                            <td>{usu.entidade.nome}</td>
                            <td>{usu.entidade.logrCidade || usu.entidade.municipio || '-'}</td>
                            <td>{usu.entidade.logrUf || usu.entidade.uf || '-'}</td>
                          </>
                        )}
                        <td>{usu.tipo}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={Entidade ? 3 : 4} className="text-center">
                      Nenhum vínculo encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </DataTable>
          </TableContainer>
        </PageContent>
        <PaginationBar setPagination={setPagination} />
        <ConfirmModal {...setConfirmModal} />
        <DefaultModal {...setDefaultModal} />
        <VinculoModal
          show={showVinculoModal}
          onClose={handleVinculoClose}
          onSuccess={handleVinculoSuccess}
          vinculoData={editingVinculo}
          usuario={Usuario}
        />
      </ResponsiveShadow>
    </Layout>
  );
}

export default Vinculos;
